/**
 * BeezFy Product Scrubber — barra fissa in basso (stile Zara), enterprise.
 * - Visibile solo con la foto del prodotto in vista; SPARISCE appena scrolli giù, riappare scrollando su.
 * - Durante il movimento (scroll striscia / hover): PREVIEW istantanea (foto + titolo + prezzo).
 * - Alla PAUSA (settle) o al TAP: COMMIT completo del prodotto via Section Rendering API
 *   (gallery, varianti, selettore colore, ATC, URL) — senza ricaricare e senza saltare la pagina.
 * - Prefetch + cache; fallback a navigazione normale su errore.
 */
(function () {
  if (window.customElements && customElements.get('product-scrubber')) return;

  var CACHE = new Map(), CACHE_CAP = 50, inflight = new Map();
  var HOVER_SETTLE = 450, SCROLL_SETTLE = 280;

  function mainEl() { return document.querySelector('.beezfy-product-premium[data-section-id]'); }
  function sectionIdOf(el) { return el ? el.getAttribute('data-section-id') : null; }
  function galleryEl() { return document.querySelector('[data-beezfy-premium-gallery]'); }
  function galleryMain() { return document.querySelector('[data-gallery-main]'); }
  function stealthBar() { return document.querySelector('.stealth-footer-bar'); }

  function cachePut(k, v) { if (CACHE.has(k)) CACHE.delete(k); CACHE.set(k, v); while (CACHE.size > CACHE_CAP) CACHE.delete(CACHE.keys().next().value); }
  function sectionUrl(href, id) { return href.split('#')[0].split('?')[0] + '?section_id=' + encodeURIComponent(id); }
  function fetchSection(href, id) {
    var k = href.split('#')[0].split('?')[0];
    if (CACHE.has(k)) return Promise.resolve(CACHE.get(k));
    if (inflight.has(k)) return inflight.get(k);
    var p = fetch(sectionUrl(href, id), { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (t) { cachePut(k, t); inflight.delete(k); return t; })
      .catch(function (e) { inflight.delete(k); throw e; });
    inflight.set(k, p); return p;
  }

  function reinit(newMain, pj) {
    try {
      if (window.BeezfyPremiumGallery) newMain.querySelectorAll('[data-beezfy-premium-gallery]').forEach(function (g) {
        if (!g._galleryInitialized) { try { g._galleryInstance = new window.BeezfyPremiumGallery(g); g._galleryInitialized = true; } catch (e) {} }
      });
    } catch (e) {}
    try {
      var bpp = window.beezfyProductPremium;
      if (bpp) {
        if (bpp.loadProductData) bpp.loadProductData();
        if (bpp.cacheElements) bpp.cacheElements();
        bpp.swatchEnhancementsReady = false;
        ['initializeVariants', 'initializeSwatchEnhancements', 'initializeQuantity', 'initializeTabs'].forEach(function (m) { if (bpp[m]) { try { bpp[m](); } catch (e) {} } });
      }
    } catch (e) {}
    // Prodotto variabile dopo lo swap: l'ATC apre il Variant Wizard (scelta varianti, come quick-add).
    // Senza questo l'ATC aggiungerebbe in silenzio la variante di default.
    try {
      var bppV = window.beezfyProductPremium;
      var prodV = (bppV && bppV.product) || (pj && pj.product) || pj;
      var multi = prodV && prodV.variants && prodV.variants.length > 1;
      var handleV = prodV && prodV.handle;
      newMain.querySelectorAll('[data-add-to-cart]').forEach(function (b) {
        if (handleV) { b.setAttribute('data-product-handle', handleV); } // l'HTML swappato può arrivare cachato senza handle
        if (multi) { b.setAttribute('data-variant-wizard-trigger', ''); }
        else { b.removeAttribute('data-variant-wizard-trigger'); }
      });
    } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: sectionIdOf(newMain) } })); } catch (e) {}
    try { var vid = pj && (pj.selectedVariantId || (pj.variants && pj.variants[0] && pj.variants[0].id)); document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variantId: vid } })); } catch (e) {}
  }
  function parseJson(root) { var s = root.querySelector('[data-beezfy-product-json]'); if (!s) return null; try { return JSON.parse(s.textContent); } catch (e) { return null; } }

  // Ri-esegue gli <script> INLINE della sezione (selettore colore mobile, touch preview, ecc.).
  // Salta gli script esterni (già caricati globalmente) e i json. Shim: i loro DOMContentLoaded partono subito.
  function runInlineScripts(root) {
    if (!root) return;
    var origAdd = document.addEventListener;
    document.addEventListener = function (type, fn, opts) {
      if (type === 'DOMContentLoaded') { try { (typeof fn === 'function') ? fn() : (fn && fn.handleEvent && fn.handleEvent()); } catch (e) {} return; }
      return origAdd.call(this, type, fn, opts);
    };
    try {
      root.querySelectorAll('script').forEach(function (old) {
        if (old.src) return;
        var t = (old.type || '').toLowerCase();
        if (t && !(t === 'text/javascript' || t === 'application/javascript')) return; // salta json/ld+json/module
        var s = document.createElement('script');
        if (old.type) s.type = old.type;
        s.textContent = old.textContent;
        old.replaceWith(s); // l'inserimento esegue lo script
      });
    } finally { document.addEventListener = origAdd; }
  }

  function ProductScrubber() { return Reflect.construct(HTMLElement, [], ProductScrubber); }
  ProductScrubber.prototype = Object.create(HTMLElement.prototype);
  ProductScrubber.prototype.constructor = ProductScrubber;

  ProductScrubber.prototype.connectedCallback = function () {
    if (this._init) return; this._init = true;
    var self = this;
    this.track = this.querySelector('[data-scrub-track]');
    this.swapping = false; this.focusItem = null; this._galleryVisible = true; this._userHidden = false; this._committing = false; this._userClosed = false; this._forceOpen = false;
    // commit da scroll SOLO dopo una reale interazione utente sulla striscia (wheel/drag/touch).
    // Evita che l'auto-centratura iniziale o un layout-shift delle immagini facciano partire
    // un swapTo('scrub') verso il prodotto che capita centrato → cambio prodotto/URL non voluto.
    this._userInteracted = false;

    // Chiudi manuale (X) + tab di riapertura (sopra la mobile bar). Stato persistente nella sessione.
    this._closeBtn = this.querySelector('[data-scrub-close]');
    this._reopenBtn = document.querySelector('[data-scrub-reopen]');
    try { if (sessionStorage.getItem('bzScrubClosed') === '1') this._userClosed = true; } catch (e) {}
    if (this._closeBtn) this._closeBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self._userClosed = true; try { sessionStorage.setItem('bzScrubClosed', '1'); } catch (e) {} self.applyVisible(); });
    if (this._reopenBtn) this._reopenBtn.addEventListener('click', function (e) { e.preventDefault(); self._userClosed = false; self._userHidden = false; self._forceOpen = true; try { sessionStorage.removeItem('bzScrubClosed'); } catch (e) {} self.applyVisible(); self.scrollActiveIntoView(true); });

    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('contextmenu', function (e) { if (e.target.closest('[data-scrub-item]')) e.preventDefault(); }); // niente menu del telefono su pressione prolungata
    // Gli item sono <a href>: di default il browser li TRASCINA (il link diventa un fantasma che segue
    // il mouse → "si attacca al mouse" e la striscia non scorre). Blocco il drag nativo del link così
    // il trascinamento scorre la striscia, come nello scrubber della QuickView (che usa <button>).
    this.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // Desktop: il semplice PASSAGGIO del mouse NON deve fare nulla (niente preview/commit "attaccati al mouse").
    // Preview e commit li pilotano SOLO il drag/rotella (scroll) e il click — come scrubbi la QV col dito.
    // Prefetch invisibile per rendere istantaneo il commit successivo.
    this.addEventListener('pointerover', function (e) { var it = e.target.closest('[data-scrub-item]'); if (it && e.pointerType !== 'touch') { self.prefetchItem(it); } });
    this.addEventListener('pointerout', function (e) { if (e.pointerType !== 'touch') { var to = e.relatedTarget; if (!to || !self.contains(to)) { clearTimeout(self._settle); self.clearFocus(); } } });
    this.addEventListener('touchstart', function (e) { self._userInteracted = true; var it = e.target.closest('[data-scrub-item]'); if (it) self.prefetchItem(it); }, { passive: true });
    // DESKTOP: rotellina verticale → scroll ORIZZONTALE della striscia (altrimenti col mouse non si scorre)
    if (this.track) this.track.addEventListener('wheel', function (e) {
      self._userInteracted = true;
      if (window.pageYOffset > 20) self.pageToTop();
      var dy = e.deltaY, dx = e.deltaX;
      if (Math.abs(dy) > Math.abs(dx)) { self.track.scrollLeft += dy; e.preventDefault(); }
    }, { passive: false });
    // DESKTOP: trascinamento col mouse (drag-to-scroll); soglia per non confondere con il click
    if (this.track) {
      var dragging = false, startX = 0, startL = 0, moved = false;
      this.track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        self._userInteracted = true;
        dragging = true; moved = false; startX = e.clientX; startL = self.track.scrollLeft;
        self.track.style.scrollBehavior = 'auto'; // Blocca lo scroll-behavior: smooth globale
        try { self.track.setPointerCapture(e.pointerId); } catch(err){}
      });
      var rAF = null;
      this.track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        var d = e.clientX - startX;
        if (Math.abs(d) > 4 && !moved) { 
          moved = true; 
          self.track.classList.add('is-dragging'); 
          if (window.pageYOffset > 20) self.pageToTop();
        }
        if (!rAF) {
          rAF = requestAnimationFrame(function() {
            try {
              self.track.scrollTo({ left: startL - d, behavior: 'auto' });
            } catch(ex) {
              self.track.scrollLeft = startL - d;
            }
            rAF = null;
          });
        }
      });
      var upCancel = function (e) {
        if (!dragging) return; dragging = false; self.track.classList.remove('is-dragging');
        self.track.style.scrollBehavior = '';
        try { self.track.releasePointerCapture(e.pointerId); } catch(err){}
        if (moved) { var blk = function (ev) { ev.preventDefault(); ev.stopPropagation(); self.track.removeEventListener('click', blk, true); }; self.track.addEventListener('click', blk, true); }
      };
      this.track.addEventListener('pointerup', upCancel);
      this.track.addEventListener('pointercancel', upCancel);
    }
    if (this.track) this.track.addEventListener('scroll', function () {
      if (self._progScroll || !self._userInteracted) return; // scroll PROGRAMMATICO (auto-centratura) o layout-shift immagini: NON cambiare prodotto, solo posizionare. Commit solo dopo reale interazione utente.
      if (window.pageYOffset > 20) self.pageToTop();
      // NB: niente pageToTop — come la QuickView, lo scrub NON sposta la pagina (era il "si muove da solo").
      if (!self._raf) self._raf = requestAnimationFrame(function () { self._raf = 0; self.focusCentered(); });
      self.armSettle(SCROLL_SETTLE);
    }, { passive: true });

    // APPENA scrolli la pagina → lo scrubber si collassa e compare il tab di riapertura.
    // Non riappare da solo: si riapre solo col tab (o resta chiuso se chiuso con la X).
    this.observeGallery();
    this._lastY = window.pageYOffset;
    this._onScroll = function () {
      if (self._committing || self._autoScroll) { self._lastY = window.pageYOffset; return; }
      var y = window.pageYOffset;
      if (y > 6 && !self._userClosed) { self._userClosed = true; self._forceOpen = false; self.applyVisible(); }
      self._lastY = y;
    };
    window.addEventListener('scroll', this._onScroll, { passive: true });

    // NB: la preview overlay (.bz-scrub-preview) NON viene creata qui all'init.
    // Appenderla a galleryMain durante il load causava un layout-shift enorme (CLS ~0.55).
    // Serve solo quando l'utente scrubba → la crea lazy showPreview()/il commit. Niente CLS al load.
    // centra il prodotto ATTUALE all'apertura — robusto ai tempi di caricamento immagini
    // (altrimenti, se l'offsetLeft è calcolato prima del load, centra il prodotto "dopo").
    var recenter = function () { self.scrollActiveIntoView(true); };
    requestAnimationFrame(function () { requestAnimationFrame(recenter); });
    [120, 350, 700, 1200].forEach(function (t) { setTimeout(recenter, t); });
    if (document.readyState !== 'complete') window.addEventListener('load', recenter, { once: true });
    var activeImg = this.querySelector('[data-scrub-item].is-active img');
    if (activeImg) { if (activeImg.complete && activeImg.naturalWidth) recenter(); else activeImg.addEventListener('load', recenter, { once: true }); }
    if (!window._bzScrubPop) {
      window._bzScrubPop = true;
      window.addEventListener('popstate', function (e) { var sc = document.querySelector('[data-product-scrubber]'); if (sc && e.state && e.state.bzScrub) sc.swapTo(location.pathname + location.search, 'pop'); });
    }
  };

  ProductScrubber.prototype.applyVisible = function () {
    var vis = (this._galleryVisible || this._forceOpen) && !this._userClosed; // visibile se foto in vista o riaperto col tab, e non chiuso/collassato
    this.classList.toggle('is-hidden', !vis);
    var s = stealthBar(); if (s) s.classList.toggle('bz-scrub-yield', vis);
    if (!vis) this.clearFocus();
    // il tab di riapertura compare SOLO se chiuso manualmente con la X (non per l'auto-hide da scroll)
    if (this._reopenBtn) {
      var closed = !!this._userClosed;
      this._reopenBtn.classList.toggle('is-on', closed);
      // posiziona il tab appena sopra la mobile bar. Uso getComputedStyle().bottom + offsetHeight
      // (indipendenti dal transform: la barra può essere in transizione "yield" quando chiudo). Su desktop senza barra resta il CSS.
      if (closed && s) {
        var cs = getComputedStyle(s), barBottom = parseFloat(cs.bottom) || 0, barH = s.offsetHeight || 0;
        if (barH > 0) this._reopenBtn.style.bottom = (barBottom + barH + 12) + 'px';
      }
    }
  };

  // Riporta la pagina in cima (così, riaprendo lo scrubber da scrollato, vedi le foto che cambiano).
  // _autoScroll sospende l'auto-chiusura su scroll durante lo scroll programmatico.
  ProductScrubber.prototype.pageToTop = function () {
    if (this._autoScroll || window.pageYOffset <= 2) return;
    var self = this; this._autoScroll = true;
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
    clearTimeout(this._asT); 
    this._asT = setTimeout(function () { self._autoScroll = false; self._lastY = window.pageYOffset; }, 1500);
    var checkTop = function() {
      if (window.pageYOffset <= 10) {
        window.removeEventListener('scroll', checkTop);
        clearTimeout(self._asT);
        setTimeout(function() { self._autoScroll = false; self._lastY = window.pageYOffset; }, 50);
      }
    };
    window.addEventListener('scroll', checkTop, {passive: true});
  };

  ProductScrubber.prototype.observeGallery = function () {
    var self = this, g = galleryEl();
    if (this._vo) this._vo.disconnect();
    if (!('IntersectionObserver' in window) || !g) { this._galleryVisible = true; this.applyVisible(); return; }
    this._vo = new IntersectionObserver(function (ents) {
      var nowVis = ents.some(function (en) { return en.isIntersecting; });
      if (nowVis && !self._galleryVisible) self._userHidden = false; // la foto rientra in vista → riappare ("sopra a tutto")
      self._galleryVisible = nowVis;
      self.applyVisible();
    }, { threshold: 0.01 });
    this._vo.observe(g);
  };

  ProductScrubber.prototype.ensureOverlay = function () {
    var host = galleryMain(); if (!host) return null;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var ov = host.querySelector('.bz-scrub-preview');
    if (!ov) { ov = document.createElement('div'); ov.className = 'bz-scrub-preview'; ov.innerHTML = '<img alt="">'; host.appendChild(ov); }
    this._overlay = ov; this._overlayImg = ov.querySelector('img'); return ov;
  };
  ProductScrubber.prototype.showPreview = function (src) {
    var ov = this._overlay && document.contains(this._overlay) ? this._overlay : this.ensureOverlay();
    if (!ov || !src) return;
    if (this._overlayImg.getAttribute('src') !== src) this._overlayImg.setAttribute('src', src);
    ov.classList.add('is-on');
  };
  ProductScrubber.prototype.hidePreview = function () { if (this._overlay) this._overlay.classList.remove('is-on'); };

  ProductScrubber.prototype.focus = function (item) {
    if (!item || item === this.focusItem) return;
    if (this.focusItem) this.focusItem.classList.remove('is-focus');
    this.focusItem = item;
    if (item.classList.contains('is-active')) { item.classList.remove('is-focus'); this.hidePreview(); this.restoreHeader(); return; }
    item.classList.add('is-focus');
    var self = this; clearTimeout(this._pv);
    this._pv = setTimeout(function () { self.showPreview(item.getAttribute('data-preview')); self.patchHeader(item); }, 60);
  };
  ProductScrubber.prototype.clearFocus = function () {
    clearTimeout(this._pv); clearTimeout(this._settle);
    if (this.focusItem) this.focusItem.classList.remove('is-focus');
    this.focusItem = null; this.hidePreview(); this.restoreHeader();
  };
  ProductScrubber.prototype.focusCentered = function () {
    if (!this.track) return;
    var mid = this.track.scrollLeft + this.track.clientWidth / 2, best = null, bd = 1e9;
    this.querySelectorAll('[data-scrub-item]').forEach(function (it) { var c = it.offsetLeft + it.clientWidth / 2, d = Math.abs(c - mid); if (d < bd) { bd = d; best = it; } });
    if (best) this.focus(best);
  };
  // alla pausa → commit completo del prodotto a fuoco
  ProductScrubber.prototype.armSettle = function (ms) {
    var self = this; clearTimeout(this._settle);
    this._settle = setTimeout(function () {
      var it = self.focusItem;
      if (it && !it.classList.contains('is-active')) self.swapTo(it.getAttribute('href'), 'scrub');
    }, ms);
  };

  ProductScrubber.prototype.patchHeader = function (item) {
    var title = item.getAttribute('data-title'), price = item.getAttribute('data-price'), compare = item.getAttribute('data-compare');
    var titles = document.querySelectorAll('.beezfy-ultra-summary__title, .beezfy-ultra-hero-compact__title');
    var prices = document.querySelectorAll('[data-price-current]'), comps = document.querySelectorAll('[data-price-compare]');
    if (!this._hdr) this._hdr = { t: [].map.call(titles, function (e) { return e.textContent; }), p: [].map.call(prices, function (e) { return e.textContent; }), c: [].map.call(comps, function (e) { return { x: e.textContent, d: e.style.display }; }) };
    [].forEach.call(titles, function (e) { if (title) e.textContent = title; });
    [].forEach.call(prices, function (e) { if (price) e.textContent = price; });
    [].forEach.call(comps, function (e) { if (compare) { e.textContent = compare; e.style.display = ''; } else { e.style.display = 'none'; } });
  };
  ProductScrubber.prototype.restoreHeader = function () {
    if (!this._hdr) return; var s = this._hdr;
    var titles = document.querySelectorAll('.beezfy-ultra-summary__title, .beezfy-ultra-hero-compact__title');
    var prices = document.querySelectorAll('[data-price-current]'), comps = document.querySelectorAll('[data-price-compare]');
    [].forEach.call(titles, function (e, i) { if (s.t[i] != null) e.textContent = s.t[i]; });
    [].forEach.call(prices, function (e, i) { if (s.p[i] != null) e.textContent = s.p[i]; });
    [].forEach.call(comps, function (e, i) { if (s.c[i]) { e.textContent = s.c[i].x; e.style.display = s.c[i].d; } });
    this._hdr = null;
  };

  ProductScrubber.prototype.prefetchItem = function (item) {
    var id = sectionIdOf(mainEl());
    if (!item || !id || item.classList.contains('is-active')) return;
    var href = item.getAttribute('href'); if (href) fetchSection(href, id).catch(function () {});
  };

  ProductScrubber.prototype.onClick = function (e) {
    var item = e.target.closest('[data-scrub-item]'); if (!item) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    if (!sectionIdOf(mainEl()) || !window.history || !window.history.pushState) return;
    e.preventDefault();
    if (item.classList.contains('is-active')) return;
    clearTimeout(this._settle);
    this.swapTo(item.getAttribute('href'), 'tap');
  };

  ProductScrubber.prototype.swapTo = function (href, mode) {
    if (this.swapping) return; var self = this;
    var id = sectionIdOf(mainEl());
    if (!id) { window.location.href = href; return; }
    
    if (window.pageYOffset > 20) this.pageToTop();
    
    this.swapping = true; this._committing = true; this.classList.add('is-swapping'); this.setAttribute('aria-busy', 'true');

    fetchSection(href, id).then(function (html) {
      var cur = mainEl();
      var wrapper = cur && (cur.closest('.shopify-section') || cur.parentElement);
      if (!cur || !wrapper) { window.location.href = href; return; }
      // estrae il contenuto sezione (gestisce risposta con o senza wrapper .shopify-section)
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var wrapInResp = tmp.querySelector('.shopify-section');
      var contentHTML = wrapInResp ? wrapInResp.innerHTML : html;
      // cleanup gallery vecchia (rimuove listener window)
      try { var og = wrapper.querySelector('[data-beezfy-premium-gallery]'); if (og && og._galleryInstance && og._galleryInstance.destroy) og._galleryInstance.destroy(); } catch (e) {}
      // swap dell'INTERA sezione (così cambiano anche JSON prodotto e <script> inline, non solo .beezfy-product-premium)
      wrapper.innerHTML = contentHTML;
      var newMain = wrapper.querySelector('.beezfy-product-premium');
      if (!newMain) { window.location.href = href; return; }
      var pj = parseJson(wrapper);
      reinit(newMain, pj);
      runInlineScripts(wrapper); // ri-esegue gli script inline (colore mobile + touch) sul nuovo DOM/JSON

      var clean = href.split('#')[0];
      try {
        if (mode === 'tap') window.history.pushState({ bzScrub: true }, '', clean);
        else if (mode === 'scrub') window.history.replaceState({ bzScrub: true }, '', clean);
      } catch (e) {}
      if (pj && pj.product && pj.product.title) { try { document.title = pj.product.title; } catch (e) {} }

      var handle = (clean.split('/products/')[1] || '').split('?')[0].replace(/\/$/, '');
      self.querySelectorAll('[data-scrub-item]').forEach(function (it) {
        var on = it.getAttribute('data-scrub-handle') === handle;
        it.classList.toggle('is-active', on); it.classList.remove('is-focus');
        if (on) it.setAttribute('aria-current', 'true'); else it.removeAttribute('aria-current');
      });
      self.focusItem = null; self._hdr = null;
      self.ensureOverlay(); self.hidePreview(); self.observeGallery(); // niente scroll pagina: la foto è già in vista
      // Come la QuickView: dopo un commit da interazione NON ri-centro la striscia (resta dove l'hai lasciata).
      // Solo sul back/forward del browser riporto l'item attivo in vista.
      if (mode === 'pop') { try { self.scrollActiveIntoView(true); } catch (e) {} }
    }).catch(function () { window.location.href = href; })
      .finally(function () {
        self.swapping = false; self.classList.remove('is-swapping'); self.removeAttribute('aria-busy');
        self._lastY = window.pageYOffset;
        setTimeout(function () { self._committing = false; }, 250);
      });
  };

  ProductScrubber.prototype.scrollActiveIntoView = function (instant) {
    var a = this.querySelector('[data-scrub-item].is-active');
    if (a && this.track) { var self = this; this._progScroll = true; clearTimeout(this._psT); this._psT = setTimeout(function () { self._progScroll = false; }, 240); var l = a.offsetLeft - this.track.clientWidth / 2 + a.clientWidth / 2; this.track.scrollTo({ left: Math.max(0, l), behavior: instant ? 'auto' : 'smooth' }); }
  };

  ProductScrubber.prototype.disconnectedCallback = function () { if (this._vo) this._vo.disconnect(); if (this._onScroll) window.removeEventListener('scroll', this._onScroll); };

  customElements.define('product-scrubber', ProductScrubber);
})();
